import { registerPlugin } from '@capacitor/core';

import type { PhonePePaymentSDK } from './definitions';

const PhonePePaymentPlugin = registerPlugin<PhonePePaymentSDK>('PhonePePaymentSDK');

export * from './definitions';
export { PhonePePaymentPlugin };
